module.exports = __webpack_public_path__ + "static/media/logo.760acda1.svg";